// extracted by mini-css-extract-plugin
export default {"logo":"Login_logo__RcE6R","form":"Login_form__63a4S","submit":"Login_submit__WPQou"};